import dayjs from 'dayjs';
import { IAidasUser } from 'app/shared/model/ainnotateservice/aidas-user.model';
import { IAidasObject } from 'app/shared/model/ainnotateservice/aidas-object.model';
import { IAidasUserAidasObjectMapping } from 'app/shared/model/ainnotateservice/aidas-user-aidas-object-mapping.model';

export interface IAidasUpload {
  id?: number;
  name?: string;
  dateUploaded?: string | null;
  status?: boolean | null;
  statusModifiedDate?: string | null;
  rejectReason?: string | null;
  aidasUserAidasObjectMapping?: IAidasUserAidasObjectMapping;
}

export const defaultValue: Readonly<IAidasUpload> = {
  status: false,
};
